import { Box, ButtonBase, Typography } from "@mui/material";

// Legend below a chart. Clicking an item shows/hides its series when
// onToggle is given.
const ChartLegend = ({ items, onToggle }) => {
  return (
    <Box
      component="ul"
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: "4px 16px",
        listStyle: "none",
        m: 0,
        p: 0,
        mt: 1.5,
      }}
    >
      {items.map((item) => {
        const content = (
          <>
            <Box
              component="span"
              sx={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                flexShrink: 0,
                backgroundColor: item.hidden ? "transparent" : item.color,
                border: `2px solid ${item.color}`,
              }}
            />
            <Typography
              component="span"
              sx={{
                fontSize: 13,
                color: item.hidden ? "text.disabled" : "text.secondary",
                textDecoration: item.hidden ? "line-through" : "none",
                whiteSpace: "nowrap",
              }}
            >
              {item.label}
            </Typography>
          </>
        );

        return (
          <Box component="li" key={item.id}>
            {onToggle ? (
              <ButtonBase
                onClick={() => onToggle(item.id)}
                aria-pressed={!item.hidden}
                title={item.hidden ? `Show ${item.label}` : `Hide ${item.label}`}
                sx={{ display: "flex", alignItems: "center", gap: 0.75, borderRadius: 1, px: 0.5, py: 0.25 }}
              >
                {content}
              </ButtonBase>
            ) : (
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, px: 0.5, py: 0.25 }}>
                {content}
              </Box>
            )}
          </Box>
        );
      })}
    </Box>
  );
};

export default ChartLegend;
